import { render, staticRenderFns } from "./StudentMenuCard.vue?vue&type=template&id=23fb4f49&scoped=true&"
import script from "./StudentMenuCard.vue?vue&type=script&lang=js&"
export * from "./StudentMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentMenuCard.vue?vue&type=style&index=0&id=23fb4f49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb4f49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VSheet})
